import { Text } from '@react-pdf/renderer';

import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { styles } from '../styles';

export const useWithPlaceholder = () => {
  const { t } = useTranslation('widgets/pdfs', {
    keyPrefix: 'lastWill',
  });

  const PlaceholderWrapper = (value: string | undefined, placeholder: string, params?: object) => {
    if (value) return value;
    return <Text style={styles.placeholder}>{t(`placeholder.${placeholder}`, { ...params })}</Text>;
  };

  return PlaceholderWrapper;
};
